import { DbMongoBaseInfos } from "./db-mongo-base-infos";

export class DbMongoSerializationBaseInfos extends DbMongoBaseInfos {}
